<div class="period-planning-cell-renderer"
  (click)="toggleExpand()">

  <al-progress-bar [value]="assignedHours"
    [maxValue]="maxValue"
    [isPercent]="false"
    [isLoading]="isLoading"
    [status]="status">
    @if (showUnplanned) {
      <span> {{(unplannedHours) | formatNumber}}
      </span>
    }
  </al-progress-bar>
</div>

<al-cell-drop-zone [node]="node"
  [droppable]="isDroppable"
  (dragOverDelay)="expand()" />
